import React from "react";
import '../styling/forms.css';

const NeedleStickInjuryForm = ({ handleFormSubmission, handleNeedleStickInjuryChange }) => {

  return (
    <div style={{ maxWidth: "400px", margin: "auto", padding: "20px", border: "1px solid #ccc", borderRadius: "8px" }}>
      <h2>Needle Stick Injury Form</h2>
      <form onSubmit={handleFormSubmission}>
        <div style={{ marginBottom: "15px" }}>
          <label htmlFor="injuryDetails" style={{ display: "block", marginBottom: "5px" }}>
            Describe the injury:
          </label>
          <textarea
            name="needleStickInjury"
            onChange={handleNeedleStickInjuryChange}
            placeholder="Provide details about the needle stick injury..."
            rows="4"
            style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
          />
        </div>
        <button type="submit">
          Submit
        </button>
      </form>
    </div>
  );
};

export default NeedleStickInjuryForm;
